import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ShieldAlert } from 'lucide-react';
import { API_URL } from '../lib/api';
import { useAuth } from '../context/AuthContext';

// Bandeau rouge : aucune sauvegarde complète ET vérifiée depuis 24 h (super administrateurs et gérants)
export function BackupAlertBanner() {
    const { user } = useAuth();
    const [st, setSt] = useState(null);
    const allowed = user && ['super_admin', 'admin'].includes(user.role);
    useEffect(() => {
        if (!allowed) return;
        axios.get(`${API_URL}/api/admin/backup/alerte`, { withCredentials: true }).then(r => setSt(r.data)).catch(() => {});
    }, [allowed]);
    if (!allowed || !st?.alerte) return null;
    const depuis = st.derniere_reussie ? new Date(st.derniere_reussie).toLocaleString('fr-FR') : null;
    const inc = st.incident;
    const old = !st.derniere_reussie || st.heures > 24;
    return (
        <div className="bg-red-600 text-white px-4 py-2.5 flex flex-wrap items-center gap-2 text-[13px]" role="alert" data-testid="backup-alert-banner">
            <ShieldAlert className="w-4 h-4 shrink-0" />
            <span className="min-w-0 break-words">
                {inc && <b data-testid="backup-alert-incident">{inc.type === 'interrompue' ? 'Dernière sauvegarde interrompue' : 'Dernière sauvegarde incomplète'} ({new Date(inc.at).toLocaleString('fr-FR')}) : {inc.detail}{inc.reprise ? ' — reprise automatique lancée' : ''}. </b>}
                {old && <b>Aucune sauvegarde vérifiée depuis plus de 24 h. </b>}
                {depuis ? `Dernière sauvegarde vérifiée : ${depuis}.` : 'Aucune sauvegarde vérifiée enregistrée.'}
            </span>
            {user.role === 'super_admin' && <Link to="/coherence" className="underline font-medium ml-auto" data-testid="backup-alert-link">Voir les sauvegardes</Link>}
        </div>
    );
}
